import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {calc_age} from 'Skelet/src/modules/time_ago.js'
import refresh_icon from './28406.svg';


class Items extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "user_list", "GET", config.api_url+"/user-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "user_list", "GET", config.api_url+"/user-list?t="+nextProps.session_token);
    }
  }

  render() {
    let card = null, cards = null, end_of_list_text = "", page_cards = this.props.apiData["user_list"], age_groups = {"0-17":0, "18-24":0, "25-34":0, "35-44":0, "45-54":0, "55-64":0, "65+":0}, age_card = null;
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        let age = 0;
        if(item.parameters !== null) {
          let user_parameters = JSON.parse(item.parameters);
          if(user_parameters["birthdate"]) age = calc_age(user_parameters["birthdate"]);
        }
        if(age < 18) {
          age_groups["0-17"] = age_groups["0-17"] + 1;
        } else if(age > 17 && age < 25) {
          age_groups["18-24"] = age_groups["18-24"] + 1;
        } else if(age > 24 && age < 35) {
          age_groups["25-34"] = age_groups["25-34"] + 1;
        } else if(age > 34 && age < 45) {
          age_groups["35-44"] = age_groups["35-44"] + 1;
        } else if(age > 44 && age < 55) {
          age_groups["45-54"] = age_groups["45-54"] + 1;
        } else if(age > 54 && age < 65) {
          age_groups["55-64"] = age_groups["55-64"] + 1;
        } else if(age > 64) {
          age_groups["65+"] = age_groups["65+"] + 1;
        }
        return <div key={"1k"+i} id={"users-"+i} className="contact">
          <div className="contact-name">{item.firstname} {item.lastname} ({item.email})</div>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.parameters}</small>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{age}</small>
        </div>;
      });
      card = <div className="card contacts">{cards}</div>;
    }

    let ages = [];
    for(const [key, value] of Object.entries(age_groups)) {
      ages.push(<div className="contact"><span style={{width:"100px", display:"inline-block"}}>{key}</span>{value}</div>);
    }
    age_card = <div className="card contacts">{ages}</div>;

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "Einde van resultaten.";
      } else {
        end_of_list_text = "Geen gebruikers.";
      }
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="refresher"><img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        {page_cards !== undefined && page_cards.data[0] !== undefined && age_card}
        {page_cards !== undefined && page_cards.data[0] !== undefined && card}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("user_list");
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Items)



// WEBPACK FOOTER //
// ./src/containers/ViewUsers.js